// extracted by mini-css-extract-plugin
module.exports = {"x-loader":"style_x-loader__10B97","x-loader-image":"style_x-loader-image__3akVp","x-loader-tip":"style_x-loader-tip__DpqEy"};